<ng-content></ng-content>


// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/syllabuses/syllabus-edit-button/syllabus-edit-button.component.ts.SyllabusEditButtonComponent.html